import React, { useEffect, useState } from "react";
import { Grid, Tooltip } from "@material-ui/core";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import CloseIcon from "@material-ui/icons/Close";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import { normalizeUnits } from "moment";


let ContactID = [];

const ConvertLead = (props) => {
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [LeadData, setLeadData] = useState([]);
    const [CompanyName, setCompanyName] = useState("");
    // const [NewContactID, setNewContactID] = useState("");
    // const [AccountID,setAccountID] = useState("");
    const [Salutation, setSalutation] = useState("");
    const [IndustryID, setIndustryID] = useState();
    const [Address1, setAddress1] = useState("");
    const [Address2, setAddress2] = useState("");
    const [Designation, setDesignation] = useState("");
    const [Department, setDepartment] = useState("");
    const [CurrencyID, setCurrencyID] = useState("");
    const [CompanyURL, setCompanyURL] = useState("");
    const [StateID, setStateID] = useState("");
    const [PinCode, setPinCode] = useState("");
    const [ContactName, setContactName] = useState("");
    const [ContactNo, setContactNo] = useState("");
    const [MobileNo, setMobileNo] = useState("");
    const [Phone, setPhone] = useState("");
    const [EmailID, setEmailID] = useState("");
    const [IsChecked, setIsChecked] = useState(false);
    const [IsopChecked, setIsopChecked] = useState(false);
    // const [IsNotChecked, setIsNotChecked] = useState(false);
    const [btnDisable, setbtnDisable] = useState(false);
    const [DisableConvetbtn, setDisableConvetbtn] = useState(false);
    const [CreateNewCompany, setCreateNewCompany] = useState(false);
    const [CreateNewConact, setCreateNewConact] = useState(false);
    const [CreateNewOpportunity, setCreateNewOpportunity] = useState(false);
    const [response, fetchData] = UseFetchData();
    const [responseCOP, fetchDataCOP] = UseFetchData();
    const [responseCC, fetchDataCC] = UseFetchData();

    const validationSchema = Yup.object({
        // CreateNewCompany: Yup.bool().oneOf([true], 'Field must be checked'),
        //CreateNewConact: Yup.string().required("Required!"),
        CreateNewOpportunity: Yup.bool().oneOf([true], 'Field must be checked'),

    });

    const onSubmit = (values) => {
        // debugger;
        // if (values.CreateNewCompany === true) {
        //     CreateCompany();
        // }
        // if (values.CreateNewOpportunity === true) {
        //     CreateNewOpp(LeadData);
        // }
        CreateNewOpportunitys(LeadData);


    }

    const onCheck = (e) => {
        // debugger;
        let targetvalue = e.target.value;
        let targetname = e.target.name;
        console.log(targetname);
        if (targetname !== "") {
            if (targetname == "CreateNewCompany") {
                setIsChecked(true);
            }
            if (targetname == "CreateNewOpportunitys") {
                setIsopChecked(true);
            }

        }
    }

    const CreateNewOpportunitys = (Data) => {
        // debugger;
        var UpdatedByID = sessionStorage.UID;
        var bodyFormData = new FormData();
        bodyFormData.append("OpportunityID", '');
        bodyFormData.append("LeadID", props.LeadID);
        bodyFormData.append("AccountName", Data[0].CompanyName);
        bodyFormData.append("CurrencyID", Data[0].CurrencyID);
        bodyFormData.append("ContactName", Data[0].ContactName);
        bodyFormData.append("LeadSourceID", Data[0].LeadSourceID);
        // bodyFormData.append("NewContactID", NewContactID);
        // bodyFormData.append("AccountID",AccountID);
        bodyFormData.append("Salutation", Salutation);
        bodyFormData.append("IsChecked", IsChecked);
        bodyFormData.append("ContactNo", ContactNo);
        bodyFormData.append("Email", EmailID);
        bodyFormData.append("Designation", Designation);
        bodyFormData.append("Department", Department);
        bodyFormData.append("Mobile", MobileNo);
        bodyFormData.append("IndustryID", IndustryID);
        bodyFormData.append("ContactNo", Phone);
        bodyFormData.append("GeneratedByID", UpdatedByID);
        bodyFormData.append("HandledByID", "");
        bodyFormData.append("BillAddress1", Data[0].Address1);
        bodyFormData.append("BillAddress2", Data[0].Address2);
        bodyFormData.append("BillCity", Data[0].City);
        bodyFormData.append("BillCountryID", Data[0].CountryID);
        bodyFormData.append("BillStateID", Data[0].StateID);
        bodyFormData.append("BillPINCode", Data[0].PINCode);
        bodyFormData.append("Phone", Data[0].Phone);
        bodyFormData.append("GSTIN", Data[0].GSTNo);
        bodyFormData.append("UpdatedByID", UpdatedByID);
        fetchDataCOP("Lead/CreateNewOpportunitys", bodyFormData);
    }

    const CreateCompany = () => {
        var bodyFormData = new FormData();
        // debugger;
        if (ContactID.length > 0) {
            for (var i = 0; i < ContactID.length; i++) {
                bodyFormData.append('ContactID[]', ContactID[i]);
            }
        }
        // debugger;
        bodyFormData.append("AccountName", CompanyName);
        bodyFormData.append("Website", CompanyURL);
        bodyFormData.append("UserID", sessionStorage.UID);
        bodyFormData.append("LeadID", props.LeadID);
        bodyFormData.append("ContactName", ContactName);
        bodyFormData.append("ContactNo", ContactNo);
        bodyFormData.append("Email", EmailID);
        bodyFormData.append("Mobile", MobileNo);
        bodyFormData.append("Designation", Designation);
        bodyFormData.append("Department", Department);
        bodyFormData.append("Address1", Address1);
        bodyFormData.append("Address2", Address2);
        bodyFormData.append("PinCode", PinCode);
        bodyFormData.append("IndustryID", IndustryID);
        bodyFormData.append("StateID", StateID);
        bodyFormData.append("Salutation", Salutation);
        bodyFormData.append("ContactNo", Phone);
        fetchDataCC("Lead/CreateNewCompanyNContacts", bodyFormData);
    }


    const CreateNewOpp = (Data) => {
        var UpdatedByID = sessionStorage.UID;
        var bodyFormData = new FormData();
        bodyFormData.append("OpportunityID", '');
        bodyFormData.append("LeadID", props.LeadID);
        bodyFormData.append("AccountName", Data[0].CompanyName);
        bodyFormData.append("ContactName", Data[0].ContactName);
        bodyFormData.append("LeadSourceID", Data[0].LeadSourceID);
        bodyFormData.append("CurrencyID", Data[0].CurrencyID);
        bodyFormData.append("GeneratedByID", UpdatedByID);
        bodyFormData.append("HandledByID", "");
        bodyFormData.append("BillAddress1", Data[0].Address1);
        bodyFormData.append("BillAddress2", Data[0].Address2);
        bodyFormData.append("BillCity", Data[0].City);
        bodyFormData.append("BillCountryID", Data[0].CountryID);
        bodyFormData.append("BillStateID", Data[0].StateID);
        bodyFormData.append("BillPINCode", Data[0].PINCode);
        bodyFormData.append("UpdatedByID", UpdatedByID);
        fetchDataCOP("Opportunity/Save", bodyFormData);
    }


    const PopulateData = (Data) => {
        var bodyFormData = new FormData();
        // debugger;
        bodyFormData.append("ContactName", Data[0].ContactName);
        bodyFormData.append("AccountName", Data[0].CompanyName);
        // bodyFormData.append("CurrencyID",Data[0].CurrencyID);
        bodyFormData.append("ContactNo", Data[0].Phone);
        bodyFormData.append("ContactURL", CompanyURL);
        bodyFormData.append("Mobile", Data[0].Mobile);
        bodyFormData.append("Email", Data[0].Email);
        fetchData("Lead/GetContactDtls", bodyFormData);
    }

    useEffect(() => {
        const gridCols = [
            {
                field: "AccountName",
                headerName: "Company Name",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "Address1",
                headerName: "Address 1",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
                renderCell: (params) => (
                    <Tooltip title={params.row.Address1} >
                        <span className="table-cell-trucate">{params.row.Address1}</span>
                    </Tooltip>
                ),
            },
            {
                field: "Address2",
                headerName: "Address 2",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
                renderCell: (params) => (
                    <Tooltip title={params.row.Address2} >
                        <span className="table-cell-trucate">{params.row.Address2}</span>
                    </Tooltip>
                ),
            },
            {
                field: "ContactName",
                headerName: "Contact Name",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "Phone",
                headerName: "Contact No",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "Mobile",
                headerName: "Mobile No",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,
            },
            {
                field: "Email",
                headerName: "Email",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,
            },
            {
                field: "Email",
                headerName: "Handled By",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,
            },
        ];
        setColumns(gridCols);
        setRows(response);
        // if (response !== undefined && response.length > 0) {
        // }
    }, [response]);


    useEffect(() => {
        if (props.LeadData !== undefined && props.LeadData.length > 0) {
            // debugger;
            setLeadData(props.LeadData);
            setContactName(props.LeadData[0].ContactName);
            setCompanyName(props.LeadData[0].CompanyName);
            setMobileNo(props.LeadData[0].Mobile);

            setCurrencyID(props.CurrencyID);
            setPhone(props.Phone);
            setEmailID(props.LeadData[0].Email);
            setContactNo(props.LeadData[0].Phone);
            setDesignation(props.LeadData[0].Designation);
            setDepartment(props.LeadData[0].Department);
            setAddress1(props.LeadData[0].Address1);
            setAddress2(props.LeadData[0].Address2);
            setStateID(props.LeadData[0].StateID);
            setPinCode(props.LeadData[0].PinCode);
            setIndustryID(props.LeadData[0].IndustryID);
            setSalutation(props.LeadData[0].Salutation);
            PopulateData(props.LeadData);
            // if (props.LeadData[0].LeadStatus === "Opportunities") {
            //     props.setDisableConvetbtn(true);
            // }
        }
    }, [props.LeadData]);

    useEffect(() => {
        // debugger;
        if (responseCOP.Response === true) {
            props.setOpenConvert(false);
            props.setDisableConvetbtn(true);
            alert('Convert Succesfully');
        }
        else if (responseCOP.Response === false) {
            alert('Failed.')
        }
    }, [responseCOP])

    return (
        <div>
            <Formik initialValues={{
                CompanyName: CompanyName, CompanyURL: CompanyURL, ContactName: ContactName, ContactNo: ContactNo, MobileNo: MobileNo, CurrencyID: CurrencyID,
                EmailID: EmailID, Designation: Designation, Department: Department, Salutation: Salutation, StateID: StateID, PinCode: PinCode, Phone: Phone,
                Address1: Address1, Address2: Address2, CreateNewCompany: CreateNewCompany, CreateNewOpportunity: CreateNewOpportunity
            }}
                validationSchema={validationSchema} onSubmit={onSubmit}>
                {(formik) => {
                    return (
                        <Form>
                            <Grid spacing={2} container direction="row">
                                <Grid item xs={12} container direction="row">
                                    <Grid item style={{ width: 110 }} >
                                        <label
                                            htmlFor={"CompanyName"}
                                            style={{ display: "block", width: "100%" }} >
                                            {"Company Name"}
                                        </label>
                                    </Grid>
                                    <Grid item xs={3} style={{ marginLeft: 7 }}>
                                        <BiztranControlsFormik
                                            control="input"
                                            type="text"
                                            // label='Company Name'
                                            name="CompanyName"
                                            value={CompanyName}
                                            disabled={true}
                                        />
                                    </Grid>
                                    <Grid item style={{ marginLeft: 7, width: 110 }} >
                                        <label
                                            htmlFor={"CompanyURL"}
                                            style={{ display: "block", width: "100%", }} >
                                            {"Company URL"}
                                        </label>
                                    </Grid>
                                    <Grid item xs={3} style={{ marginLeft: 7 }}>
                                        <BiztranControlsFormik
                                            control="input"
                                            type="text"
                                            // label='Company URL'
                                            name="CompanyURL"
                                            value={CompanyURL}
                                            disabled={true}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} container direction="row">
                                    <Grid item style={{ width: 110 }} >
                                        <label
                                            htmlFor={"ContactName"}
                                            style={{ display: "block", width: "100%", }} >
                                            {"Contact Name"}
                                        </label>
                                    </Grid>
                                    <Grid item xs={3} style={{ marginLeft: 7 }}>
                                        <BiztranControlsFormik
                                            control="input"
                                            type="text"
                                            // label='Contact Name'
                                            name="ContactName"
                                            value={ContactName}
                                            disabled={true}
                                        />
                                    </Grid>
                                    <Grid item style={{ marginLeft: 7, width: 110 }} >
                                        <label
                                            htmlFor={"ContactNo"}
                                            style={{ display: "block", width: "100%", }} >
                                            {"Contact No"}
                                        </label>
                                    </Grid>
                                    <Grid item xs={3} style={{ marginLeft: 7 }}>
                                        <BiztranControlsFormik
                                            control="input"
                                            type="text"
                                            // label='Contact No'
                                            name="ContactNo"
                                            value={ContactNo}
                                            disabled={true}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} container direction="row">
                                    <Grid item style={{ width: 110 }} >
                                        <label
                                            htmlFor={"MobileNo"}
                                            style={{ display: "block", width: "100%", }} >
                                            {"Mobile No"}
                                        </label>
                                    </Grid>
                                    <Grid item xs={3} style={{ marginLeft: 7 }}>
                                        <BiztranControlsFormik
                                            control="input"
                                            type="text"
                                            // label='Mobile No'
                                            name="MobileNo"
                                            value={MobileNo}
                                            disabled={true}
                                        />
                                    </Grid>
                                    <Grid item style={{ marginLeft: 7, width: 110 }}>
                                        <label
                                            htmlFor={"EmailID"}
                                            style={{ display: "block", width: "100%", }} >
                                            {"Email ID"}
                                        </label>
                                    </Grid>
                                    <Grid item xs={3} style={{ marginLeft: 7 }}>
                                        <BiztranControlsFormik
                                            control="input"
                                            type="text"
                                            // label='Email ID'
                                            name="EmailID"
                                            value={EmailID}
                                            disabled={true}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <BiztranControls.DataGrid
                                        headerHeight={34}
                                        rowHeight={25}
                                        rows={rows}
                                        columns={columns}
                                        checkboxSelection={true}
                                        hideFooterPagination={true}
                                        hideFooter={true}
                                        Height="240px"
                                        //Height="700px"
                                        Width="100%"
                                        onSelectionModelChange={(newSelection) => {
                                            //console.log(newSelection);
                                            ContactID = newSelection;
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} container direction="row">
                                    <Grid item xs={4}>
                                        <BiztranControlsFormik
                                            control="checkbox"
                                            name="CreateNewCompany"
                                            label="Create a New Company & Contact"
                                            //checked={IsChecked}
                                            onClick={onCheck}

                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <BiztranControlsFormik
                                            control="checkbox"
                                            name="CreateNewOpportunity"
                                            label="Create a New Opportunity"
                                            onClick={onCheck}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%" }}>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignContent: "center",
                                            }}
                                        >
                                            <BiztranControls.Button
                                                text="CONVERT"
                                                type="submit"

                                                startIcon={<SwapHorizIcon />}
                                            // disabled = {!formik.isValid}
                                            />
                                            <BiztranControls.Button
                                                text="CLOSE"
                                                startIcon={<CloseIcon />}
                                                onClick={() => {
                                                    props.setOpenConvert(false);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
        </div>
    );
}

export default ConvertLead;
